// extracted by mini-css-extract-plugin
export default {"tags":"ProjectSkillTags_tags__qhHe1","tag":"ProjectSkillTags_tag__GDKv3","icon":"ProjectSkillTags_icon__+-Ha2","skillText":"ProjectSkillTags_skillText__SbEYR"};